/* Prepared companion for kindveil-newsbreak-custom-pixel.js; not a second pixel. */
(() => {
  'use strict';
  if (window.__kvNewsBreakBundlePublisher || window.Shopify?.shop !== 'xdq4ry-he.myshopify.com') return;
  if (!/^\/products\/kind-veil-bb-blur-tinted-moisturizer-spf-30\/?$/.test(location.pathname)) return;
  window.__kvNewsBreakBundlePublisher = true;
  const seen = new WeakSet();
  const checkouts = new Set();
  let customCheckoutPending = false;
  let ownCheckoutEvent = false;
  let filteredPixel;
  // Suppress only NewsBreak's premature plugin click event for this custom buy-now button.
  // Other platforms, ordinary cart checkout, and all commerce handlers remain untouched.
  function filterCheckoutPixel() {
    const original = window.nbpix;
    if (typeof original !== 'function' || original === filteredPixel) return;
    filteredPixel = new Proxy(original, {apply(target, receiver, args) {
      if (customCheckoutPending && !ownCheckoutEvent && args[0] === 'event' && args[1] === 'initiate_checkout') return;
      return Reflect.apply(target, receiver, args);
    }});
    window.nbpix = filteredPixel;
  }
  window.addEventListener('click', event => {
    const button = event.target?.closest?.('[data-kind-veil-product] #yx_checkout, product-info #yx_checkout');
    if (!button) return;
    customCheckoutPending = true;
    filterCheckoutPixel();
    const observer = new MutationObserver(() => {
      if (button.getAttribute('aria-busy') !== 'true') {
        customCheckoutPending = false;
        observer.disconnect();
      }
    });
    observer.observe(button, {attributes: true, attributeFilter: ['aria-busy']});
  }, true);
  document.addEventListener('kindveil:checkout-created', event => {
    try {
      const detail = event.detail || {};
      const privacy = window.Shopify?.customerPrivacy;
      if (!detail.checkoutId || checkouts.has(detail.checkoutId) || !privacy?.marketingAllowed?.() || !privacy?.saleOfDataAllowed?.()) return;
      const value = Number(detail.value);
      if (!Number.isFinite(value) || value <= 0 || typeof window.nbpix !== 'function') return;
      checkouts.add(detail.checkoutId);
      // The existing checkout SDK uses sendBeacon, so navigation need not be delayed.
      ownCheckoutEvent = true;
      try { window.nbpix('event', 'initiate_checkout', {nb_value: Math.round(value * 100) / 100}); }
      finally { ownCheckoutEvent = false; }
    } catch (_) { /* Tracking is never a prerequisite for checkout. */ }
  });
  document.addEventListener('shopify:cart:lines-update', event => {
    try {
      const root = event.target?.closest?.('[data-kind-veil-product]');
      if (!root || event.action !== 'add' || event.context !== 'product' || !event.promise?.then || seen.has(event.promise)) return;
      seen.add(event.promise);
      const card = root.querySelector('[data-kv-tier].is-selected');
      const input = root.querySelector('input[name="subscription_enabled"]');
      const cents = Number(card?.dataset.basePrice);
      const discount = input?.checked ? Number(input.dataset.discountRate) : 0;
      if (!Number.isFinite(cents) || cents <= 0 || !Number.isFinite(discount) || discount < 0 || discount > 100) return;
      const value = Math.round(cents * (1 - discount / 100)) / 100;
      const actionId = crypto.randomUUID();
      event.promise.then(result => {
        const detail = result?.detail;
        if (detail?.source !== 'kind-veil-fixed-bundle' || detail.didError || !detail.items?.length) return;
        window.Shopify?.analytics?.publish?.('kindveil_bundle_added', {source: detail.source, value, actionId});
      }).catch(() => {});
    } catch (_) { /* Never modify or interrupt the cart operation. */ }
  });
})();
